// extracted by mini-css-extract-plugin
module.exports = {"mobileToolbarHolder":"MobileToolbar_mobileToolbarHolder__3-sQc","mobileToolbarButtonsHolder":"MobileToolbar_mobileToolbarButtonsHolder__1ehDh"};